import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMoreInput} from "../abstract-more-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineMoreInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-more-input",
    templateUrl: "./inline-more-input.component.html",
    standalone: false
})
export class FUIInlineMoreInputComponent extends FUIAbstractMoreInput {
    constructor(elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, eventsService, optionsService, changeDetectorRef);
    }
}
